<span>{{ duration() || '—' }}</span>
